import { UseToastOptions, createStandaloneToast } from '@chakra-ui/react'

const { toast } = createStandaloneToast()

export const showToast = (toastOption: UseToastOptions) => {
  if (toastOption.id && toast.isActive(toastOption.id)) {
    return
  }
    const position = toastOption.position || 'top-right'
  return toast({ position, isClosable: true, ...toastOption })
}
